(function () {
  if (window.BollideCartOptimization) return;
  window.BollideCartOptimization = true;

  function updateEstimatedDelivery() {
    var deliveryDate = new Date();
    var formatter;
    var label;

    deliveryDate.setHours(12, 0, 0, 0);
    deliveryDate.setDate(deliveryDate.getDate() + 4);

    try {
      formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric'
      });
      label = formatter.format(deliveryDate);
    } catch (error) {
      label = deliveryDate.toLocaleDateString();
    }

    document.querySelectorAll('[data-cart-delivery-date]').forEach(function (node) {
      var drawer = node.closest('[data-cart-drawer]');
      var row = node.closest('.cart-drawer__delivery');
      var hasPreorder = Boolean(drawer && drawer.querySelector('.cart__item__selling-plan'));

      if (row) row.hidden = hasPreorder;
      if (hasPreorder) return;

      node.textContent = label;
      node.setAttribute(
        'datetime',
        deliveryDate.getFullYear() + '-' +
          String(deliveryDate.getMonth() + 1).padStart(2, '0') + '-' +
          String(deliveryDate.getDate()).padStart(2, '0')
      );
    });
  }

  var expressOpener = null;
  var suppressEscapeKeyup = false;
  var suppressEscapeTimer = null;

  function setInert(node, shouldBeInert) {
    if (!node) return;

    if ('inert' in node) {
      node.inert = shouldBeInert;
    }

    if (shouldBeInert) {
      node.setAttribute('inert', '');
    } else {
      node.removeAttribute('inert');
    }
  }

  function getOpenExpressSheet() {
    return document.querySelector('[data-cart-express-sheet].is-open');
  }

  function setExpressBackgroundInert(sheet, shouldBeInert) {
    var drawer = sheet && sheet.closest('[data-cart-drawer]');
    if (!drawer) return;

    [
      drawer.querySelector('.cart-drawer__head'),
      drawer.querySelector('[data-cart-drawer-body]'),
      drawer.querySelector('.cart__foot-inner'),
      drawer.querySelector('.cart-drawer__empty-message--bottom')
    ].forEach(function (node) {
      setInert(node, shouldBeInert);
    });
  }

  function setExpressTabStops(sheet, isOpen) {
    var tabIndex = isOpen ? '0' : '-1';

    sheet.querySelectorAll(
      '.cart-express-sheet__close, [data-cart-express-standard], [data-cart-express-focus-start], [data-cart-express-focus-end]'
    ).forEach(function (node) {
      node.setAttribute('tabindex', tabIndex);
    });

    var backdrop = sheet.querySelector('.cart-express-sheet__backdrop');
    if (backdrop) backdrop.setAttribute('tabindex', '-1');
  }

  function openExpressSheet(trigger) {
    var drawer = trigger && trigger.closest('[data-cart-drawer]');
    var sheet = drawer && drawer.querySelector('[data-cart-express-sheet]');
    var title;

    if (!sheet || trigger.hidden || sheet.classList.contains('is-open')) return;

    if (!sheet.__bollideExpressPointerGuard) {
      sheet.addEventListener('mousedown', function (event) {
        event.stopPropagation();
      });
      sheet.__bollideExpressPointerGuard = true;
    }

    if (sheet.parentElement !== drawer) {
      drawer.appendChild(sheet);
    }

    expressOpener = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    setExpressBackgroundInert(sheet, true);
    setInert(sheet, false);
    setExpressTabStops(sheet, true);
    sheet.setAttribute('aria-hidden', 'false');
    sheet.classList.add('is-open');
    document.body.classList.add('js-cart-express-open');

    title = sheet.querySelector('.cart-express-sheet__title');
    window.requestAnimationFrame(function () {
      if (title && sheet.classList.contains('is-open')) {
        title.focus({preventScroll: true});
      }
    });
  }

  function closeExpressSheet(sheet, focusTarget) {
    var drawer;
    var trigger;

    if (!sheet) return;

    drawer = sheet.closest('[data-cart-drawer]');
    trigger = expressOpener || (drawer && drawer.querySelector('[data-cart-express-trigger]'));

    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    setExpressTabStops(sheet, false);
    setInert(sheet, true);
    setExpressBackgroundInert(sheet, false);
    document.body.classList.remove('js-cart-express-open');

    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    if (focusTarget && focusTarget.isConnected && document.body.classList.contains('js-drawer-open-cart')) {
      window.requestAnimationFrame(function () {
        focusTarget.focus({preventScroll: true});
      });
    }

    expressOpener = null;
  }

  function walletMarkupIsReady(sheet) {
    var walletHolder = sheet && sheet.querySelector('[data-additional-checkout-button]');
    return Boolean(walletHolder && walletHolder.children.length);
  }

  function applePayIsAvailable() {
    try {
      return Boolean(
        window.ApplePaySession &&
        typeof window.ApplePaySession.canMakePayments === 'function' &&
        window.ApplePaySession.canMakePayments()
      );
    } catch (error) {
      return false;
    }
  }

  function syncExpressPaymentMarks() {
    var applePayAvailable = applePayIsAvailable();

    document.querySelectorAll('[data-cart-express-payment-icons]').forEach(function (iconRail) {
      var applePayMark = iconRail.querySelector('[data-express-payment-type="apple_pay"]');
      var googlePayMark = iconRail.querySelector('[data-express-payment-type="google_pay"]');
      var useApplePay = Boolean(applePayMark && applePayAvailable);

      if (applePayMark) applePayMark.hidden = !useApplePay;
      if (googlePayMark) googlePayMark.hidden = useApplePay;

      iconRail.dataset.primaryWallet = useApplePay
        ? 'apple_pay'
        : (googlePayMark ? 'google_pay' : 'none');
    });
  }

  function syncExpressSheet(sheet) {
    var drawer = sheet && sheet.closest('[data-cart-drawer]');
    var trigger = drawer && drawer.querySelector('[data-cart-express-trigger]');
    var walletHolder = sheet && sheet.querySelector('[data-additional-checkout-button]');
    var isReady = walletMarkupIsReady(sheet);

    if (!trigger || !walletHolder) return;

    trigger.hidden = !isReady;

    if (!isReady && sheet.classList.contains('is-open')) {
      closeExpressSheet(sheet, false);
    }

    if (walletHolder.dataset.cartExpressObserved !== 'true') {
      walletHolder.dataset.cartExpressObserved = 'true';

      new MutationObserver(function () {
        var activeSheet = getOpenExpressSheet();
        syncExpressSheet(sheet);

        if (activeSheet === sheet && !sheet.contains(document.activeElement)) {
          var closeButton = sheet.querySelector('.cart-express-sheet__close');
          if (closeButton) window.requestAnimationFrame(function () { closeButton.focus({preventScroll: true}); });
        }
      }).observe(walletHolder, {childList: true, subtree: true});
    }
  }

  function syncExpressCheckout() {
    syncExpressPaymentMarks();
    document.querySelectorAll('[data-cart-express-sheet]').forEach(syncExpressSheet);
  }

  function isEscapeKey(event) {
    return event.key === 'Escape' || event.code === 'Escape' || event.keyCode === 27;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-express-trigger]');
    var closeControl = event.target.closest('[data-cart-express-close]');
    var sheet;
    var focusTarget;

    if (trigger) {
      event.preventDefault();
      openExpressSheet(trigger);
      return;
    }

    if (!closeControl) return;

    sheet = closeControl.closest('[data-cart-express-sheet]');
    if (!sheet) return;

    event.preventDefault();
    event.stopPropagation();

    if (closeControl.hasAttribute('data-cart-express-standard')) {
      focusTarget = sheet.closest('[data-cart-drawer]').querySelector('.cart__checkout');
    } else {
      focusTarget = expressOpener;
    }

    closeExpressSheet(sheet, focusTarget);
  }, true);

  document.addEventListener('focusin', function (event) {
    var sheet = getOpenExpressSheet();
    var focusTarget;

    if (!sheet) return;

    if (event.target.hasAttribute('data-cart-express-focus-start')) {
      focusTarget = sheet.querySelector('[data-cart-express-standard]');
    } else if (event.target.hasAttribute('data-cart-express-focus-end')) {
      focusTarget = sheet.querySelector('.cart-express-sheet__close');
    } else if (!sheet.contains(event.target)) {
      focusTarget = sheet.querySelector('.cart-express-sheet__close');
    }

    if (focusTarget) {
      window.requestAnimationFrame(function () {
        focusTarget.focus({preventScroll: true});
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    var sheet = getOpenExpressSheet();

    if (!sheet || !isEscapeKey(event)) return;

    event.preventDefault();
    event.stopPropagation();
    suppressEscapeKeyup = true;
    window.clearTimeout(suppressEscapeTimer);
    suppressEscapeTimer = window.setTimeout(function () {
      suppressEscapeKeyup = false;
    }, 800);
    closeExpressSheet(sheet, expressOpener);
  }, true);

  document.addEventListener('keyup', function (event) {
    if (!suppressEscapeKeyup || !isEscapeKey(event)) return;

    event.preventDefault();
    event.stopPropagation();
    suppressEscapeKeyup = false;
    window.clearTimeout(suppressEscapeTimer);
  }, true);

  document.addEventListener('theme:cart:close', function () {
    closeExpressSheet(getOpenExpressSheet(), false);
  });

  document.addEventListener('theme:cart:added', function () {
    closeExpressSheet(getOpenExpressSheet(), false);
    syncExpressCheckout();
  });

  document.addEventListener('theme:cart:loaded', function () {
    updateEstimatedDelivery();
    syncExpressCheckout();
  });

  document.addEventListener('theme:cart:open', function () {
    updateEstimatedDelivery();
    syncExpressCheckout();
  });

  document.addEventListener('shopify:section:load', function () {
    updateEstimatedDelivery();
    syncExpressCheckout();
  });

  window.addEventListener('pageshow', syncExpressCheckout);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateEstimatedDelivery();
      syncExpressCheckout();
    });
  } else {
    updateEstimatedDelivery();
    syncExpressCheckout();
  }
})();
